import PlantelActions from "./PlantelActions";

const PlantelRow = ({ plantel }) => {
  const isActive = plantel.is_active;

  return (
    <tr>
      <td>
        <span className="text-md fw-medium text-primary-light">
          {plantel.nombre}
        </span>
      </td>
      <td>
        <span className="text-sm d-block text-secondary-light">
          {plantel.clave}
        </span>
      </td>
      <td>
        <div className="d-flex flex-column">
          <span className="text-sm fw-medium text-primary-light">
            {plantel.escuela_nombre}
          </span>
          <span className="text-xs text-secondary-light">
            {plantel.escuela_siglas}
          </span>
        </div>
      </td>
      <td>
        <span
          className={`px-3 py-1 rounded-pill fw-medium text-sm ${
            isActive
              ? "bg-success-focus text-success-main"
              : "bg-danger-focus text-danger-main"
          }`}
        >
          {isActive ? "Activo" : "Inactivo"}
        </span>
      </td>
      <td>
        <span className="text-center text-neutral-700 text-xl">
          <PlantelActions plantel={plantel} />
        </span>
      </td>
    </tr>
  );
};

export default PlantelRow;
